import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const RefreshIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.9824 2L11.9824 3.98962C7.57247 3.99898 4 7.57944 4 11.9949C4 13.5564 4.44698 15.0127 5.21932 16.2444L6.81587 15.0532C6.28681 14.1569 5.98272 13.1116 5.98272 11.9949C5.98272 8.67532 8.66718 5.98349 11.9824 5.9737L11.9824 8.00417L14.165 6.37545L15.9589 5.03698L16.0061 5.00209L11.9824 2Z"
          fill="black"
        />
        <path
          d="M18.7454 7.68921L17.1501 8.87957C17.7004 9.78863 18.0173 10.8547 18.0173 11.9949C18.0173 15.3204 15.3234 18.0161 12.0002 18.0161C11.9942 18.0161 11.9887 18.0161 11.9828 18.0156L11.9828 15.9958L9.82141 17.6083L8.02965 18.9455L7.95947 18.9979L11.9832 22L11.9832 19.9997C11.9891 19.9997 11.9947 20.0001 12.0006 20.0001C16.419 20.0001 20.0004 16.4159 20.0004 11.9949C20 10.4096 19.5394 8.93235 18.7454 7.68921Z"
          fill="black"
        />
      </svg>
    )
  },
)
